
import { useNavigate } from "react-router-dom";
import { Badge } from "../ui/badge";
import { ActionItem } from "../../types/actionItems";
import { DashboardActionItemCard } from "./DashboardActionItemCard";
import { LucideIcon } from "lucide-react";
import { Button } from "../ui/button";
import React from "react";

interface TaskSectionProps {
  title: string;
  items: ActionItem[];
  icon: LucideIcon;
}

const MAX_ITEMS_TO_SHOW = 5;

export const TaskSection = ({ title, items, icon: Icon }: TaskSectionProps) => {
  const navigate = useNavigate();
  
  if (items.length === 0) return null;

  const displayedItems = items.slice(0, MAX_ITEMS_TO_SHOW);
  const remainingCount = items.length - MAX_ITEMS_TO_SHOW;

  const handleViewMore = () => {
    navigate('/app/action-items');
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 px-2">
        <Icon className="h-4 w-4" />
        <h3 className="text-sm font-semibold">{title}</h3>
        <div className="flex items-center justify-center w-6 h-6 rounded-full bg-black text-white text-xs font-medium">
          {items.length}
        </div>
      </div>
      <div className="space-y-2">
        {displayedItems.map((item) => (
          <DashboardActionItemCard key={item.id} item={item} />
        ))}
        
        {remainingCount > 0 && (
          <Button
            variant="ghost"
            className="w-full text-sm text-gray-500 hover:text-gray-700"
            onClick={handleViewMore}
          >
            +{remainingCount} more items
          </Button>
        )}
      </div>
    </div>
  );
};